import { render, staticRenderFns } from "./collection-page.vue?vue&type=template&id=c2978a50&"
import script from "./collection-page.vue?vue&type=script&lang=js&"
export * from "./collection-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports